/**
 * Browser entry point for Assembler library
 * This file exports only the browser-compatible modules
 */

// Common utilities
export { AssemblerConfig, CommonUtil, findMatchingCloseTag, isAlphaNumeric, normalizeFileContent, parseComponentReusePattern, removeRemainingSlotPlaceholders, replaceCaseInsensitive, utf16Len } from '../../../Assembler/dist/common/commonUtil.js';

// Model classes
export { JsonArrayPlaceholder, JsonArraySkipPlaceholder, JsonKeyPlaceholder, OperationsMetadata, PreprocessedTemplate, ReplacementMapping, ReplacementType, SlotPlaceholder, SlottedTemplate, TemplateOperation, TemplatePlaceholder } from '../../../Assembler/dist/model/index.js';

// JSON utilities
export { JsonMergeUtil, mergeTemplateWithJson } from '../../../Assembler/dist/base/engine/jsonMergeUtil.js';

// Engines (pure algorithms)
export { EngineNormal } from '../../../Assembler/dist/normal/engine/engineNormal.js';
export { EnginePreProcess } from '../../../Assembler/dist/preprocess/engine/enginePreProcess.js';

// Main loaders (with fromDict for client-side use)
export { LoaderNormal } from '../../../Assembler/dist/normal/loader/loaderNormal.js';
export { LoaderPreProcess } from '../../../Assembler/dist/preprocess/loader/loaderPreProcess.js';

// JSON data structures
export { JsonUtility } from '../../../Assembler/dist/app/jsonUtility.js';
export { JsonArray, JsonObject, JsonValue } from '../../../Assembler/dist/app/json/jsonValue.js';

// Browser-compatible Logger (from Arshu - aliased by build.js)
export { LogLevel, Logger } from '../../../Arshu/dist/logger/LoggerBrowser.js';

// AssemblerClient - Core client-side merge logic (lives in AssemblerQuality)
export { AssemblerClient } from '../../../AssemblerQuality/dist/apiclient/assemblerClient.js';

// RegistryStore - For registering IData handlers (needed for dynamic data in client mode)
export { RegistryStore } from '../../../Assembler/dist/registry/registryStore.js';
export { RegisterBase } from '../registryBase/registerBase.js';
export { IRegistry } from '../../../Assembler/dist/registry/iface/iRegistry.js';
export { IData } from '../../../Assembler/dist/registry/iface/iData.js';

// View + Client registrars - the only two handler kinds the client tier needs. Both are free of server
// dependencies by construction (RegisterServer, which owns the ConfigFile-backed data providers, is
// deliberately NOT exported here — bundling it would drag fs/path/crypto into the browser).
export { RegisterView } from '../registryView/registerView.js';
export { RegisterClient } from '../registryClient/registerClient.js';

// Client handlers - the client-tier processors that consume the server-delivered raw data island and
// filter/render it in the browser, running the same body as the console --apiclient/--ociclient simulation.
export { IClient } from '../../../Assembler/dist/registry/iface/iClient.js';
export { AppSiteFoldersClient } from '../registryClient/dynamicClient/appSiteFoldersClient.js';
export { ScenarioClient } from '../registryClient/dynamicClient/scenarioClient.js';
export { TimeClient } from '../registryClient/dynamicClient/timeClient.js';
export { CounterClient } from '../registryClient/dynamicClient/counterClient.js';

// Shared pure filters backing the client handlers (no IO, no ConfigFile) - exported so custom client
// handlers can reuse the exact same single-source filter the server applies.
export { EnrichedScenario, ScenariosFilter } from '../registryCommon/dynamicData/scenariosFilter.js';
export { AppSiteFoldersFilter } from '../registryCommon/dynamicData/appSiteFoldersFilter.js';
export { TimeFilter } from '../registryCommon/dynamicData/timeFilter.js';
export { CounterFilter } from '../registryCommon/dynamicData/counterFilter.js';
